import PropTypes from "prop-types";
import { GRADE_STYLES, DEFAULT_GRADE_STYLE, QUESTION_TYPES } from "./constants";

// A React ref accepts either a callback ref or a ref object ({ current }).
export const refPropType = PropTypes.oneOfType([
  PropTypes.func,
  PropTypes.shape({ current: PropTypes.any }),
]);

export const getGradeStyle = (grade) => {
  return GRADE_STYLES[grade] || DEFAULT_GRADE_STYLE;
};

// Test-out assessments use the base key; all other cases use the `_standard` variant.
export const assessmentCopyKey = (baseKey, testOut) => (
  testOut === true ? baseKey : `${baseKey}_standard`
);

export const getFirstUnansweredIndex = (attempt) => {
  if (!attempt?.questions?.length) {
    return 0;
  }
  const index = attempt.questions.findIndex((question) => !question.response);
  return index === -1 ? 0 : index;
};

export const shouldShowIntroForAttempt = (attempt) => {
  if (attempt.status !== "IN_PROGRESS") {
    return false;
  }
  const firstQuestion = attempt.questions?.[0];
  return Boolean(firstQuestion) && !firstQuestion.response;
};

export const sortQuestionsByOrder = (attempt) => {
  if (!attempt?.questions?.length) {
    return attempt;
  }
  return {
    ...attempt,
    questions: [...attempt.questions].sort((a, b) => a.questionOrder - b.questionOrder),
  };
};

export const isMcqKnowledgeCheck = (knowledgeCheck) => knowledgeCheck?.type?.toUpperCase() === QUESTION_TYPES.MCQ;

export const isSaqKnowledgeCheck = (knowledgeCheck) => knowledgeCheck?.type?.toUpperCase() === QUESTION_TYPES.SAQ;